import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
    Button, Form, Input, message, Select
} from 'antd';
import { formItemLayout, tailLayout } from './ModalLayout';
import * as Service from '../core/Service';
import { useTranslation } from 'react-i18next';

const OrderForm = (props) => {
    const {t} = useTranslation();

    const [form] = Form.useForm();
    const [formData, setFormData] = useState({});
    const { Option } = Select;
    const {
        selectedRecord,
        openModal
    } = props;

    useEffect(() => {
        form.resetFields();
        setFormData(selectedRecord);
    }, [form, selectedRecord]);

    useEffect(() => {
        form.setFieldsValue(formData);
    }, [form, formData]);

    const onFinish = async (formObj) => {
        let method = `PUT`;
        let endpoint = `/api/order`;

        let bodyObj = _.clone(formObj);
        console.log("BobyObj", bodyObj);

        try {
            let resp = await Service.call(method, endpoint, bodyObj);
            if (resp.errorMessage) {
                message.error(resp.errorMessage);
                return;
            }
            message.success(t('common.success'));
            return openModal(false);
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <Form
            {...formItemLayout}
            form={form}
            onFinish={onFinish}
            initialValues={formData}
        >
            <Form.Item
                name="order_id"
                label={t('order_list.order_id')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="status"
                label={t('common.status')}
                rules={[{ required: true, message: `Please input` }]}
            >
                <Select
                    placeholder="Select a status"
                >
                    <Option value={0}>{t('order_status.normal')}</Option>
                    <Option value={1}>{t('order_status.driver_taken')}</Option>
                    <Option value={2}>{t('order_status.user_confirmed')}</Option>
                    <Option value={3}>{t('order_status.finished')}</Option>
                    <Option value={4}>{t('order_status.cancelled_by_user')}</Option>
                    <Option value={5}>{t('order_status.cancelled_by_driver')}</Option>
                    <Option value={6}>{t('order_status.cancelled_by_driver_and_back_to_pool')}</Option>
                    <Option value={7}>{t('order_status.timeout')}</Option>
                    <Option value={8}>{t('order_status.other')}</Option>
                </Select>
            </Form.Item>
            <Form.Item
                name="order_type"
                label={t('order_list.order_type')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Select
                    disabled
                >
                    <Option value={0}>{t('order_type.call_cars_now')}</Option>
                    <Option value={1}>{t('order_type.book_cars')}</Option>
                </Select>
            </Form.Item>
            <Form.Item
                name="order_date"
                label={t('order_list.order_date')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="order_time"
                label={t('order_list.order_time')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="start_address"
                label={t('order_list.start_address')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input.TextArea disabled={true} />
            </Form.Item>
            <Form.Item
                name="end_address"
                label={t('order_list.end_address')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input.TextArea disabled={true} />
            </Form.Item>
            <Form.Item
                name="customer_appkey"
                label={t('order_list.customer_appkey')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="customer_contact_number"
                label={t('order_list.customer_contact_number')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="tunnel_id"
                label={t('order_list.tunnel_id')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="tips"
                label={t('order_list.tips')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="requested_seat_number"
                label={t('order_list.requested_seat_number')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="pets"
                label={t('order_list.pets')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="call_fee"
                label={t('order_list.call_fee')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="speak_in_english"
                label={t('order_list.speak_in_english')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="driver_id"
                label={t('driver.driver_id')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="vehicle_id"
                label={t('vehicle.vehicle_id')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="start_time"
                label={t('common.start_time')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="end_time"
                label={t('common.end_time')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="remarks"
                label={t('common.remarks')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input.TextArea disabled={true} />
            </Form.Item>
            <Form.Item
                name="recreated_order_id"
                label={t('order_list.recreated_order_id')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input disabled={true} />
            </Form.Item>
            <Form.Item
                name="translate_start_address"
                label={t('order_list.translate_start_address')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input.TextArea disabled={true} />
            </Form.Item>
            <Form.Item
                name="translate_end_address"
                label={t('order_list.translate_end_address')}
                rules={[{ required: false, message: `Please input` }]}
            >
                <Input.TextArea disabled={true} />
            </Form.Item>
            <Form.Item {...tailLayout}>
                <Button
                    type="primary"
                    htmlType="submit"
                >
                    {t('common.submit')}
                </Button>
            </Form.Item>
        </Form >
    );
}

export default OrderForm;
